import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from '../core/layout/layout.component';

import { AuthGuardService } from 'src/app/modules/core/services/auth-guard.service';

import { DistributorLoginComponent } from 'src/app/modules/distributor/distributor-login/distributor-login.component';
import { ChangePasswordComponent } from 'src/app/modules/distributor/change-password/change-password.component';
import { CouponListComponent } from 'src/app/modules/distributor/coupon/coupon-list/coupon-list.component';
import { CouponReportComponent } from 'src/app/modules/distributor/reports/coupon-report/coupon-report.component';
import { PaymentsComponent } from 'src/app/modules/distributor/payments/payments.component';


const routes: Routes = [
  { path: 'distributor', component: DistributorLoginComponent },
  { path: 'distributor/change-password', component: LayoutComponent, data: { module:'distributor' }, // Change Password
        children: [
            { path: '', component: ChangePasswordComponent, canActivate: [AuthGuardService], data: { module:'distributor', menuCode: 'D-ALL-USERS_ACCESS' } } 
        ]
    },
  { path: 'distributor/coupon-list', component: LayoutComponent, data: { module:'distributor' }, // Coupon List
    children: [
        { path: '', component: CouponListComponent, canActivate: [AuthGuardService], data: { module:'distributor', menuCode: 'D-CL' } }
    ]
  },
  { path: 'distributor/reports', component: LayoutComponent, data: { module:'distributor' }, // Reports
    children: [
        { path: '', component: CouponReportComponent, canActivate: [AuthGuardService], data: { module:'distributor', menuCode: 'D-RP' } }
    ]
  },
  { path: 'distributor/payments', component: LayoutComponent, data: { module:'distributor' }, // Payments
    children: [
        { path: '', component: PaymentsComponent, canActivate: [AuthGuardService], data: { module:'distributor', menuCode: 'D-PA' } }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DistributorRoutingModule { }
